// extracted by mini-css-extract-plugin
module.exports = {"mainPanel":"MainPanel__mainPanel--2iNI7","approvalActions":"MainPanel__approvalActions--23JXb"};